module.exports = __webpack_public_path__ + "static/img/loading2.736e4d4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading2.gif
// module id = aKXg
// module chunks = 3